import React from 'react';
import Masonry from 'react-masonry-component';

import './styles.css';
import { Loading } from '../../../components';
import HotelItem from './hotel-item';

export const Hotels: React.FC = () => {
    return (
        <div className="clearfix">
            <Masonry className="item-list-container" >
                {DummyContent.map((item, i) => {
                    return (
                        <HotelItem key={i} item={item} />
                    )
                }
                )}
            </Masonry>
            <Loading />
        </div>
    );
}

export default Hotels;

const DummyContent = [
    {
        rating: 4.5,
        imagePath: '/images/luptatum-switzerland.jpg',
        title: 'Biohof Herrenweg, Schilta...',
        subTitle: 'Lorem ipsum dolor sit amet',

    },
    {
        rating: 4.5,
        imagePath: '/images/coliseum-italy.jpg',
        title: 'Leisure and sports center...',
        subTitle: 'Lorem ipsum dolor sit amet',

    },
    {
        rating: 3.5,
        imagePath: '/images/praesent-luptatum-china.jpg',
        title: 'Praesent Luptatum',
        subTitle: 'Lorem ipsum dolor sit amet',

    },
    {
        rating: 3.5,
        imagePath: '/images/blanditcanada.jpg',
        title: 'Biohof Herrenweg, Schilta...',
        subTitle: 'Lorem ipsum dolor sit ame',

    },
    {
        rating: 2.4,
        imagePath: '/images/constanta-la-reunion.jpg',
        title: 'Constanta, La Reunion',
        subTitle: 'Lorem ipsum dolor sit amet',

    },
    {
        rating: 1.2,
        imagePath: '/images/blandit-praesen-andorra.jpg',
        title: 'Blandit Praesent, Andorra',
        subTitle: 'Lorem ipsum dolor sit ame',

    },
    {
        rating: 4.5,
        imagePath: '/images/sighisoara-romania.jpg',
        title: 'Sighisoara, Romania',
        subTitle: 'Lorem ipsum dolor ',

    }
]
